import labels, { inputValidationLabels, chatMessageErrorLabels, countries, languages } from '../data/labels';
import adminLabels from '../data/adminLabels';
import { useMemo } from 'react';

export default function useLabels() {
    return labels;
}

export function useAdminLabels() {
    return adminLabels;
}

export function useCountries() {
    return countries;
}

export function useLanguages() {
    return countries;
}

export const useLov = () => {
    const lov = useMemo(() => ({
        country: countries,
        language: languages
    }), []);
    return lov;
};
export function useInputValidationLabels() {
    return inputValidationLabels;
}
export function useChatMessageErrorLabels() {
    return chatMessageErrorLabels;
}